import React, { useEffect, useState } from "react";
import { Controller } from "react-hook-form";
import {
  Autocomplete,
  Box,
  Button,
  CircularProgress,
  TextField,
} from "@mui/material";
import useCustomerFilters from "../../resources/customers/components/CustomerFilterHelper";
import { useGetCustomersHandler } from "../../resources/customers/dataHandlers/getCustomersHandler";
import CustomerPopupModal from "./CustomerPopupModal";

const CustomerSelect = ({
  label = "Billed to",
  name,
  control,
  errors,
  readOnly = false,
  onSelect,
  setError,
  onCustomerLoaded,
  invoiceType,
}) => {
  const { currentQuery, handleSearchChange } = useCustomerFilters({
    defaultQuery: {},
    searchOnChange: true,
  });
  const [open, setOpen] = useState(false);

  const { customers, isLoading } = useGetCustomersHandler({
    searchQuery: {
      ...currentQuery,
      customer_type: invoiceType === "FULL" ? "BUSINESS" : "",
    },
    invoiceType,
  });

  const getCustomerOptionLabel = (option) =>
  {
    if(option?.postal_address?.country_code === "OM"){
      return `${option?.name || ""} | ${option?.email || ""} | ${option?.party_tax_scheme?.company_id || ""}`;
    }
    else{
      return `${option?.name || ""} | ${option?.email || ""} `;
    }
  }

  useEffect(() => {
    if (customers) {
      onCustomerLoaded?.(customers);
    }
  }, [customers, onCustomerLoaded]);

  const handleOpen = () => setOpen(true);
  const handleClose = () => setOpen(false);

  return (
    <>
      <Controller
        name={name}
        control={control}
        render={({ field }) => (
          <Box display="flex" alignItems="flex-start" gap={2}>
            <Autocomplete
              {...field}
              id={name}
              fullWidth
              loading={isLoading}
              readOnly={readOnly}
              options={customers}
              getOptionLabel={getCustomerOptionLabel}
              getOptionKey={(option) => option?.id}
              renderInput={(params) => (
                <TextField
                  {...params}
                  label={label}
                  error={!!errors}
                  helperText={errors || ''}
                  slotProps={{
                    input: {
                      ...params.InputProps,
                      endAdornment: (
                        <React.Fragment>
                          {isLoading ? (
                            <CircularProgress color="inherit" size={20} />
                          ) : null}
                          {params.InputProps.endAdornment}
                        </React.Fragment>
                      ),
                    },
                  }}
                />
              )}
              isOptionEqualToValue={(option, value) =>
                option.value === value.value
              }
              onChange={(_, value) => field.onChange(value)}
              value={field?.value || null}
              onInputChange={(event, value, reason) => {
                if (reason === "input") {
                  handleSearchChange(event);
                }
              }}
              filterOptions={(x) => x}
            />
            {!readOnly && invoiceType === "SIMPLIFIED" && (
              <Button
                id="add-walk-in-customer"
                variant="contained"
                color="primary"
                sx={{ py: 1 }}
                onClick={handleOpen}
              >
                Add
              </Button>
            )}
          </Box>
        )}
      />
      {open && (
        <CustomerPopupModal
          open={open}
          handleClose={handleClose}
          onSave={onSelect}
          setError={setError}
        />
      )}
    </>
  );
};

export default CustomerSelect;
